// import React, { useState } from "react";
// import DataMonitoringTabs from "./DataMonitoringTabs";
// import PowerBIFrame from "./PowerBIFrame";
// import DataTable from "./DataTable";
// import "./dataMonitoring.css";
// import OverallReport from "./OverallReport";

// const DataMonitoring = () => {
//   const [activeTab, setActiveTab] = useState(1);

//   const powerBiReports = [
   
//     {
//       url: "https://app.powerbi.com/reportEmbed?reportId=da924ab7-707e-45b8-b746-f81d62b1a0b0&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
//       title: "PRR and Code Rating_V1",
//     },
//     {
//       url: "https://app.powerbi.com/reportEmbed?reportId=75795b57-0fd3-4c32-b420-1b7e7abf69e4&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
//       title: "SFU Usage Metrics",
//     },
//     {
//       url: "https://app.powerbi.com/reportEmbed?reportId=cb27a488-9a6d-4a0b-a8ab-f4e6459d26a4&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
//       title: "Cost_Monitoring_Report",
//     },
//     {
//       url: "https://app.powerbi.com/reportEmbed?reportId=a952c72d-d4b3-4ddf-8532-b16fce0d5686&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
//       title: "Snacking_Data_Platform_KPIs",
//     },
//     {
//       url: "https://app.powerbi.com/reportEmbed?reportId=a43cc5ac-0375-47a9-8416-79fd4e39cf39&autoAuth=true&ctid=2fc13e34-f03f-498b-982a-7cb446e25bc6",
//       title: "Usage Analytics Dashboard PROD",
//     },
//   ];


//   return (
//     <div className="dm-container">
//     <div className="dm-layout">
//       <div className="dm-left-text">
//           <h2 key={activeTab} className="fade-in-heading">
//             {tabNames[activeTab - 1]}
//           </h2>
//           </div>
//       <div className="dm-right-tabs">
//         <DataMonitoringTabs activeTab={activeTab} setActiveTab={setActiveTab} />
//       </div>
//     </div>
//            <div className="dm-header">  </div>


//     <div className="dm-content-box">
//       {activeTab === 1 ? (
//         <OverallReport />
//       ) : activeTab >= 2 && activeTab <= 6 ? (
//         <PowerBIFrame
//           url={powerBiReports[activeTab - 2].url}
//           title={powerBiReports[activeTab - 2].title}
//         />
//       ) : (
//         <DataTable />
//       )}
//     </div>
//   </div>
//   );
// };

// export default DataMonitoring;
import React, { useState } from "react";
import DataMonitoringTabs from "./DataMonitoringTabs";
import PowerBIFrame from "./PowerBIFrame";
import DataTable from "./DataTable";
import "./dataMonitoring.css";
import OverallReport from "./OverallReport";

const DataMonitoring = () => {
  const [activeTab, setActiveTab] = useState(1);

  const tabNames = [
    "Data Quality Holistic",
    "Code Quality",
    "SFU Usage Metrics",
    "Cost Monitoring",
    "Platform KPI",
    "Product Usage",
    "Product View",
  ];

  const powerBiReports = [
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=78bafad2-1d12-47c7-a78d-9862e850ff9a&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454",
      title: "PRR and Code Rating_V1",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=78bafad2-1d12-47c7-a78d-9862e850ff9a&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454",
      title: "SFU Usage Metrics",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=78bafad2-1d12-47c7-a78d-9862e850ff9a&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454",
      title: "Cost_Monitoring_Report",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=78bafad2-1d12-47c7-a78d-9862e850ff9a&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454",
      title: "Snacking_Data_Platform_KPIs",
    },
    {
      url: "https://app.powerbi.com/reportEmbed?reportId=78bafad2-1d12-47c7-a78d-9862e850ff9a&autoAuth=true&ctid=f9233a40-fb1a-464d-b85a-959e3ab8e454",
      title: "Usage Analytics Dashboard PROD",
    },
  ];

  return (
    <div className="dm-container">
      <div className="dm-layout">
        <div className="dm-left-text">
          <h2 key={activeTab} className="tab-title-animate">
            {tabNames[activeTab - 1]}
          </h2>
        </div>
        <div className="dm-right-tabs">
          <DataMonitoringTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        </div>
      </div>
            <div className="dm-header">  </div>

      <div className="dm-content-box">
        {activeTab === 1 ? (
          <OverallReport />
        ) : activeTab >= 2 && activeTab <= 6 ? (
          <PowerBIFrame
            url={powerBiReports[activeTab - 2].url}
            title={powerBiReports[activeTab - 2].title}
          />
        ) : (
          <DataTable />
        )}
      </div>
    </div>
  );
};

export default DataMonitoring;
